import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import BookingForm from "./BookingForm";

export const openBooking = () => window.dispatchEvent(new CustomEvent("open-booking"));

export default function BookingModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onOpen = () => setOpen(true);
    const onClick = (e) => {
      const link = e.target && e.target.closest && e.target.closest('a[href="/book-appointment"]');
      if (link) {
        e.preventDefault();
        e.stopPropagation();
        setOpen(true);
      }
    };
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("open-booking", onOpen);
    document.addEventListener("click", onClick, true);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("open-booking", onOpen);
      document.removeEventListener("click", onClick, true);
      window.removeEventListener("keydown", onKey);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          data-testid="booking-modal-overlay"
          onClick={() => setOpen(false)}
          className="fixed inset-0 z-[70] flex items-start sm:items-center justify-center overflow-y-auto bg-teal-obsidian/80 backdrop-blur-md p-4 sm:p-8"
        >
          <motion.div
            initial={{ opacity: 0, y: 36, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.98 }}
            transition={{ duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
            data-testid="booking-modal"
            className="relative w-full max-w-2xl my-8"
          >
            <button
              data-testid="booking-modal-close"
              onClick={() => setOpen(false)}
              aria-label="Close booking form"
              className="absolute -top-2 -right-2 sm:-top-3 sm:-right-3 z-10 h-10 w-10 rounded-full bg-white text-teal-brand shadow-lg flex items-center justify-center hover:bg-gold-soft active:scale-95 transition-all duration-200"
            >
              <X size={18} />
            </button>
            <BookingForm />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
